import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { EngagementFinishSurveyFormDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  formId: string
  onCancel?: () => void
  onSuccess?: () => void
}

export function FinishSurveyDialog({ formId, onCancel, onSuccess }: Props) {
  const [finishForm] = useMutation(EngagementFinishSurveyFormDocument, {
    extractorFn: (data) => data.formsMutations.finishFormsForm,
  })

  return (
    <Dialog
      open
      onClose={onCancel}
      header={{
        title: i18n.t('surveys.finish_survey_dialog.title'),
        description: i18n.t('surveys.finish_survey_dialog.description'),
        type: 'critical',
      }}
      actions={{
        primary: {
          label: i18n.t('surveys.finish_survey_dialog.finish'),
          variant: 'critical',
          onClick: async () => {
            const response = await finishForm({
              variables: {
                formId,
              },
            })

            const handled = handleResult(response, () => {})

            if (handled.success) {
              onSuccess?.()
            }
          },
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: () => onCancel?.(),
        },
      }}
    />
  )
}
